$(document).ready(function() {
    $('.testimonial-slider').slick({
        autoplay: false,
        autoplaySpeed: 1000,
        speed: 1000,
        draggable: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
    });

  $('.testimonial-slider').on('afterChange', function(event, slick, currentSlide) {
      if (currentSlide === slick.$slides.length - slick.options.slidesToShow) {
          $('.slick_next').addClass('disable'); 
      } else {
          $('.slick_next').removeClass('disable');
      }
      if (currentSlide === 0) {
          $('.slick_prev').addClass('disable');
      } else {
          $('.slick_prev').removeClass('disable'); 
      }
  });
  $('.slick-button-wrap .slick_prev').on('click', function() {
      $('.testimonial-slider').slick('slickPrev');
  });
  $('.slick-button-wrap .slick_next').on('click', function() {
      $('.testimonial-slider').slick('slickNext');
  });
  
  $(".accordian-box .accordion-title").on('click',function() {
    $('.accordian-box .accordion-title').not($(this)).removeClass('active');
    $('.accordian-box .accordion-content').not($(this).next()).slideUp();
    $(this).toggleClass('active');
    $(this).next().slideToggle(250);
  }).filter(':first').click();

  $(".additinal-warranty-section .dropdawn-title").on('click',function() {
    // $('.additinal-warranty-section .dropdawn-title').not($(this)).removeClass('active');
    // $('.additinal-warranty-section .dropdawn-content').not($(this).next()).slideUp();
    $(this).toggleClass('active');
    $(this).next().slideToggle(250);
  });

  $('.search-inner-right button').on('click', function() {
      const searchText = $('.search-inner-right input').val()
      const mainOrigin = window.location.origin;

    if(searchText){
      const URL = mainOrigin+'/search?q='+searchText
      window.location = URL
    }
  });

  $('.product-option').each(function(){
    let left = $(this).find('dt').text()?.replaceAll(':','')?.trim()
    let right = $(this).find('dd').text()?.replaceAll(':','')?.trim()
    if(left == right){
        $(this).find('dd').text('Selected')
    }
  })
  
}); 


$(window).on('load',function() {
  equalheight('.what-we-do-section .wwd-box');
  equalheight('.pricing-section .pricing-box');
  equalheight('.two-column-section .two-column-box');
  equalheight('.gen-shocks-section .gen-shocks-box');
  equalheight('.swd-col-box .swd-content');
}); 

$(window).on('resize',function() {
  equalheight('.what-we-do-section .wwd-box');
  equalheight('.pricing-section .pricing-box');
  equalheight('.two-column-section .two-column-box');
  equalheight('.gen-shocks-section .gen-shocks-box');
  equalheight('.swd-col-box .swd-content');
}); 


equalheight = function(container) {

  var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el,
    topPosition = 0;
  $(container).each(function() {

    $el = $(this);
    $($el).height('auto')
    topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; 
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}